export const FETCH_CLIENTS_INDUSTRIES_REQUEST =
  "FETCH_CLIENTS_INDUSTRIES_REQUEST";
export const FETCH_CLIENTS_INDUSTRIES_SUCCESS =
  "FETCH_CLIENTS_INDUSTRIES_SUCCESS";
export const FETCH_CLIENTS_INDUSTRIES_FAILURE =
  "FETCH_CLIENTS_INDUSTRIES_FAILURE";

export const fetchClientsIndustriesRequest = () => ({
  type: FETCH_CLIENTS_INDUSTRIES_REQUEST,
});

export const fetchClientsIndustriesSuccess = (payload) => ({
  type: FETCH_CLIENTS_INDUSTRIES_SUCCESS,
  payload,
});

export const fetchClientsIndustriesFailure = (error) => ({
  type: FETCH_CLIENTS_INDUSTRIES_FAILURE,
  payload: error,
});
